import { Routes } from '@angular/router';
import { EnterpriseSubscriptionGuard } from '../security/enterprise-subscription.guard';
import { PermissionGuard } from '../security/permission.guard';
import { app_permissions } from '../security/app-permissions';
import { BusinessEventAlertsComponent } from './business-event-alerts.component';
import { BusinessEventExecutionsComponent } from './business-event-executions.component';
import { BusinessEventTemplatesComponent } from './business-event-templates.component';
import { BusinessEventTeamsComponent } from './business-event-teams.component';

export const businessEventRoutes: Routes = [
  {
    path: 'business-events',
    pathMatch: 'full',
    redirectTo: 'business-events/alerts'
  },
  {
    path: 'business-events/alerts',
    component: BusinessEventAlertsComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      enterpriseModules: ['WORKFLOW_AUTOMATION', 'WASENDER'],
      enterpriseFeatureLabel: 'Business Events',
      permission: app_permissions.business_events.view
    }
  },
  {
    path: 'business-events/rules',
    redirectTo: 'business-events/alerts',
    pathMatch: 'full'
  },
  {
    path: 'business-events/teams',
    component: BusinessEventTeamsComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      enterpriseModules: ['WORKFLOW_AUTOMATION', 'WASENDER'],
      enterpriseFeatureLabel: 'Business Events',
      permission: app_permissions.business_events.view
    }
  },
  {
    path: 'business-events/templates',
    component: BusinessEventTemplatesComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      enterpriseModules: ['WORKFLOW_AUTOMATION', 'WASENDER'],
      enterpriseFeatureLabel: 'Business Events',
      permission: app_permissions.business_events.view
    }
  },
  {
    path: 'business-events/executions',
    component: BusinessEventExecutionsComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    data: {
      enterpriseModules: ['WORKFLOW_AUTOMATION', 'WASENDER'],
      enterpriseFeatureLabel: 'Business Events',
      permission: app_permissions.business_events.view
    }
  }
];
